query holidays($scenarioId: ID!) {
  data(scenarioId: $scenarioId) {
    holidays {
      id
      code
      name
      date
    }
  }
}
